import * as React from 'react';

type InputProps = Partial<React.ComponentPropsWithRef<'input'>>;

/**
 * `slotProps.input` for MUI's Switch, Checkbox and Radio, with `FieldController`'s `inputRef` as the input's ref:
 * they have no `inputRef` prop. Not MUI's `mergeSlotProps`, which gives the input the root's class when
 * `slotProps.input` is a function.
 */
export function inputSlotWithRef<TOwnerState>(
    input: InputProps | ((ownerState: TOwnerState) => InputProps) | undefined,
    inputRef: React.Ref<HTMLInputElement> | undefined,
) {
    return (ownerState: TOwnerState): InputProps => ({
        ref: inputRef,
        ...(typeof input === 'function' ? input(ownerState) : input),
    });
}
